import React, {useState, useEffect, Fragment, useCallback} from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import DocumentView from "../../../../../../components/sales/downloadDocView/documentView";
import Layout from "../../../../../../components/sales/layout/layout";
import {toast} from "react-toastify";
import FormSection from "../../../../../../components/sales/formSection/formSection";
import s from "../../../../../../components/sales/paymentPortal/addPayment/addPayment.module.css";
import DropDownInput from "../../../../../../components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "../../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import ModalPop from "../../../../../../components/sales/modal/modal";
import FileUpload from "../../../../../../components/sales/fileUpload/fileUpload";
import moment from "moment";

const RTODocuments = ({
    match,
    caseStatusUpdateResponse = [],
    documentUploadUrlPublic,
    documentUrlDataPublic,
    rcCaseByIdResponse = [],
    rcCaseByIdRequest,
    rtoDetailsUpdateRequest,
    rtoDetailsUpdateResponse = [],
    rtoInputList,
    handleInput,
    handleRtoInput,
    handleRTODetailsSubmit,
    submitStatus,
    inputList
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState("");
    const [changeCarLoanStatusModalOpen, setChangeCarLoanStatusModalOpen] =
        useState(false);
    const [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState();
    const [remark, setRemark] = useState();
    // const [inputList, setInputList] = useState([]);
    // const [rtoInputList, setRtoInputList] = useState([{
    //     document_status: '',
    //     rto_amount: '',
    //     challan_exists: '',
    //     challan_document: '',
    //     remark: '',
    //     document_confirmation: '',
    //     documents: [],
    //     agent_name:'',
    //     agent_number:'',
    //     agent_email: ''
    // }]);
    const [documentCollectedConfirm, setDocumentCollectedConfirm] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
            setRoleId(window.localStorage.getItem("fusion-role"));
            await rcCaseByIdRequest(match?.params?.application_id)
        })();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        if (rcCaseByIdResponse?.data?.mediator) {
            handleRtoInput('mediator', rcCaseByIdResponse.data.mediator);
        }
    }, [rcCaseByIdResponse?.data?.mediator]);

    return (
            <Fragment>
                <div className="panel-card">
                    <div className="panel-heading">RTO Details</div>
                    <div className="panel-body">
                        <div className="details-listing">
                            <div className="row">
                                {rcCaseByIdResponse?.data?.rto_amount &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"RTO Amount"}
                                            data={
                                                rcCaseByIdResponse?.data?.rto_amount
                                                    ? rcCaseByIdResponse?.data?.rto_amount
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }
                                {rcCaseByIdResponse?.data?.challan_exists &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"Challan Exists"}
                                            data={
                                                rcCaseByIdResponse?.data?.challan_exists
                                                    ? rcCaseByIdResponse?.data?.challan_exists ? "Yes" : "No"
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }

                                {rcCaseByIdResponse?.data?.challan_amount &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"Challan Amount"}
                                            data={
                                                rcCaseByIdResponse?.data?.challan_amount
                                                    ? rcCaseByIdResponse?.data?.challan_amount
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }


                                {!rcCaseByIdResponse?.data?.rto_amount &&
                                    <div className="col-md-3 col-sm-12">
                                        <ConstantInput
                                            label={"RTO Amount"}
                                            handleChange={(val) =>
                                                handleRtoInput('rto_amount', val)
                                            }
                                            value={rtoInputList[0]?.rto_amount}
                                            // disabled={isEdit}
                                            type="number"
                                            step={"any"}      // Allows decimal input
                                            decimal={'decimal'}
                                        />
                                    </div>
                                }
                                <div className="col-md-4">
                                    <DropDownInput
                                        label={'Mediator'}
                                        data={[
                                        { id: "PARKPLUS", name: "PARKPLUS"}, 
                                        { id: "DEALER", name: "DEALER"},
                                        { id: "OTHERS", name: "OTHERS"}
                                        ]}
                                        getIdValue={(val) => {
                                            handleRtoInput('mediator', val.id);
                                        }}
                                        disabled={rcCaseByIdResponse?.data?.current_state !== "DOCUMENT_PICKUP_PENDING"}
                                        getValueById={rtoInputList[0]?.mediator} 
                                    />
                                </div>

                                {!rcCaseByIdResponse?.data?.challan_exists &&
                                    <>

                                        <div className="col-sm-4">
                                            <DropDownInput
                                                label={'Existing Challan'}
                                                data={[{id: "Yes", name: "Yes"}, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleRtoInput('challan_exists', val.id,);
                                                }}
                                                value={rtoInputList[0]?.challan_exists}
                                                // isStarRequired={true}
                                                // required={true}
                                                // disabled={true}
                                            />
                                        </div>
                                        {rtoInputList[0]?.challan_exists !== undefined && rtoInputList[0]?.challan_exists === 'Yes' &&
                                            <>
                                                <div className="col-md-3 col-sm-12">
                                                    <ConstantInput
                                                        label={"Challan Amount"}
                                                        handleChange={(val) =>
                                                            handleRtoInput('challan_amount', val)
                                                        }
                                                        value={rtoInputList[0]?.challan_amount}
                                                        // disabled={isEdit}
                                                        type="number"
                                                        step={"any"}      // Allows decimal input
                                                        decimal={'decimal'}
                                                    />
                                                </div>
                                                <div className="col-md-13 col-sm-12">
                                                    <FileUpload
                                                        id={"challan_document"}
                                                        accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                        documentUploadUrl={documentUploadUrlPublic}
                                                        documentUrlData={documentUrlDataPublic}
                                                        onChange={(val) => handleRtoInput('CHALLAN', val,)}
                                                        prefilledFilename={rtoInputList[0]?.challan_document ? "Challan Reference" : ""}
                                                        width={"100%"}
                                                    >
                                                      <span className="btn btn-transparent"
                                                            style={{minWidth: '100%'}}>Challan Reference<div
                                                          style={{color: "red"}}>*</div></span>
                                                    </FileUpload>
                                                </div>
                                            </>
                                        }
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel-card">
                    <div className="panel-heading">Agent Details</div>
                    <div className="panel-body">
                        <div className="details-listing">
                            <div className="row">
                                {rcCaseByIdResponse?.data?.agent_name &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"Agent Name"}
                                            data={
                                                rcCaseByIdResponse?.data?.agent_name
                                                    ? rcCaseByIdResponse?.data?.agent_name
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }
                                {rcCaseByIdResponse?.data?.agent_number &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"Agent Number"}
                                            data={
                                                rcCaseByIdResponse?.data?.agent_number
                                                    ? rcCaseByIdResponse?.data?.agent_number
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }

                                {rcCaseByIdResponse?.data?.agent_email &&
                                    <div className="col-6">
                                        <DivLayout
                                            heading={"Agent Email"}
                                            data={
                                                rcCaseByIdResponse?.data?.agent_email
                                                    ? rcCaseByIdResponse?.data?.agent_email
                                                    : localization.na
                                            }
                                        />
                                    </div>
                                }

                                {!rcCaseByIdResponse?.data?.agent_name &&
                                    <div className="col-6">
                                        <ConstantInput
                                            label={"Agent Name"}
                                            handleChange={(val) =>
                                                handleRtoInput('agent_name', val)
                                            }
                                            value={rtoInputList[0]?.agent_name}
                                            // disabled={isEdit}
                                            type="text"
                                        />
                                    </div>
                                }
                                {!rcCaseByIdResponse?.data?.agent_number &&
                                    <div className="col-6">
                                        <ConstantInput
                                            label={"Agent Number"}
                                            handleChange={(val) =>
                                                handleRtoInput('agent_number', val)
                                            }
                                            value={rtoInputList[0]?.agent_number}
                                            // disabled={isEdit}
                                            type="text"
                                            checkDigits={true}
                                            maxLength={10}
                                            minLength={10}
                                        />
                                    </div>
                                }
                                {!rcCaseByIdResponse?.data?.agent_email &&
                                    <div className="col-6">
                                        <ConstantInput
                                            label={"Agent Email"}
                                            handleChange={(val) =>
                                                handleRtoInput('agent_email', val)
                                            }
                                            value={rtoInputList[0]?.agent_email}
                                            // disabled={isEdit}
                                            type="email"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel-card">
                    <div className="panel-heading">Remark History</div>
                    <div className="panel-body">
                        <div className="details-listing">
                            <div className="row">
                                <table className="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>Remark</th>
                                        <th>Time</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.remarks && rcCaseByIdResponse?.data?.remarks.map((val, i) => {
                                        return (
                                            <>
                                                <tr>
                                                    <th>{val.value}</th>
                                                    <th>{moment(val.timestamp).format('YYYY-MM-DD HH:mm:ss')}</th>
                                                </tr>
                                            </>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="panel-card">
                    <div className="panel-heading">Details</div>
                    <div className="panel-body">
                        <div className="details-listing">
                            <div className="row">
                                {rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.user_details &&
                                    <>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Name"}
                                                data={
                                                    rcCaseByIdResponse?.data?.user_details?.name
                                                        ? rcCaseByIdResponse?.data?.user_details?.name
                                                        : localization.na
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Email"}
                                                data={
                                                    rcCaseByIdResponse?.data?.user_details?.email
                                                        ? rcCaseByIdResponse?.data?.user_details?.email
                                                        : localization.na
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Phone No"}
                                                data={
                                                    rcCaseByIdResponse?.data?.user_details?.phone_number
                                                        ? rcCaseByIdResponse?.data?.user_details?.phone_number
                                                        : localization.na
                                                }
                                            />
                                        </div>
                                    </>
                                }
                                <div className="col-6">
                                    <DivLayout
                                        heading={"Channel Name"}
                                        data={
                                            rcCaseByIdResponse?.data?.channel_name
                                                ? rcCaseByIdResponse?.data?.channel_name
                                                : localization.na
                                        }
                                    />
                                </div>
                                <div className="col-6">
                                    <DivLayout
                                        heading={"Channel Type"}
                                        data={
                                            rcCaseByIdResponse?.data?.channel_type
                                                ? rcCaseByIdResponse?.data?.channel_type
                                                : localization.na
                                        }
                                    />
                                </div>
                                <div className="col-6">
                                    <DivLayout
                                        heading={"Current State"}
                                        data={
                                            rcCaseByIdResponse?.data?.current_state
                                                ? rcCaseByIdResponse?.data?.current_state
                                                : localization.na
                                        }
                                    />
                                </div>
                                {rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.loan_details &&
                                    <>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Loan Id"}
                                                data={
                                                    rcCaseByIdResponse?.data?.loan_details?.loan_id
                                                        ? rcCaseByIdResponse?.data?.loan_details?.loan_id
                                                        : localization.na
                                                }
                                            />
                                        </div>
                                        {/*<div className="col-6">*/}
                                        {/*    <DivLayout*/}
                                        {/*        heading={"UTR No"}*/}
                                        {/*        data={*/}
                                        {/*            rcCaseByIdResponse?.data?.loan_details?.transaction_utr_number*/}
                                        {/*                ? rcCaseByIdResponse?.data?.loan_details?.transaction_utr_number*/}
                                        {/*                : localization.na*/}
                                        {/*        }*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Loan Type"}
                                                data={
                                                    rcCaseByIdResponse?.data?.loan_details?.type
                                                        ? rcCaseByIdResponse?.data?.loan_details?.type
                                                        : localization.na
                                                }
                                            />
                                        </div>
                                        <div className="col-6">
                                            <DivLayout
                                                heading={"Hypothecation"}
                                                data={
                                                    rcCaseByIdResponse?.data?.loan_details?.hypothecation ? 'true' : 'false'
                                                }
                                            />
                                        </div>

                                        {/*<div className="col-6">*/}
                                        {/*    <DivLayout*/}
                                        {/*        heading={"Amount"}*/}
                                        {/*        data={*/}
                                        {/*            rcCaseByIdResponse?.data?.loan_details?.loan_amount*/}
                                        {/*                ? rcCaseByIdResponse?.data?.loan_details?.loan_amount*/}
                                        {/*                : localization.na*/}
                                        {/*        }*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </>
                                }
                                {rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.documents &&
                                    rcCaseByIdResponse?.data?.documents.map((item, i) => {
                                        return (
                                            <>
                                                {item?.url &&
                                                    <div className="col-md-6 col-sm-12">
                                                        <DocumentView
                                                            attachment={
                                                                item?.url
                                                            }
                                                            title={item?.title}
                                                        />
                                                    </div>
                                                }

                                                {(!item?.url && item?.type !== 18) &&
                                                    <div className="col-md-6 col-sm-12" key={i + 1}>
                                                        <FileUpload
                                                            id={item?.title}
                                                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                            documentUploadUrl={documentUploadUrlPublic}
                                                            documentUrlData={documentUrlDataPublic}
                                                            onChange={(val) => handleInput(val, item?.name, item?.type, item?.document_id ?? "", i)}
                                                            prefilledFilename={(inputList[i] && inputList[i]['url'] !== undefined) ? item?.title : ""}
                                                            width={"100%"}
                                                        >
                                                                      <span className="btn btn-transparent"
                                                                            style={{minWidth: '100%'}}>{item?.title}
                                                                          {item?.required &&
                                                                              <>
                                                                                  <div
                                                                                      style={{color: "red"}}>*
                                                                                  </div>
                                                                              </>
                                                                          }
                                                                        </span>
                                                        </FileUpload>
                                                    </div>
                                                }

                                            </>
                                        )
                                    })

                                }
                                <div className="col-md-12 col-sm-12 mt-5">
                                    <ConstantInput
                                        label={"Remark"}
                                        handleChange={(val) =>
                                            handleRtoInput('remark', val)
                                        }
                                        value={rtoInputList[0]?.remark}
                                        // disabled={isEdit}
                                        type="text"
                                    />
                                </div>
                                {/* <div className="col-md-12 mb-2">
                                    <center>
                                        <Button onClick={(e) => {
                                            handleRTODetailsSubmit(e)
                                        }}>
                                            Submit
                                        </Button>
                                    </center>
                                </div> */}
                                {/*  {loanApplicationByIdResponse?.data?.loan_type && loanApplicationByIdResponse?.data?.loan_type === 'Balance Transfer' &&*/}
                                {/*      <>*/}
                                {/*          <div className="col-md-3 col-sm-12">*/}
                                {/*              <FileUpload*/}
                                {/*                  id={"bank_noc_form_35"}*/}
                                {/*                  accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*                  documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*                  documentUrlData={documentUrlDataPublic}*/}
                                {/*                  onChange={(val) => handleInput(val, 'bank_noc_form_35')}*/}
                                {/*                  prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Bank NOC -Form 35" : ""}*/}
                                {/*                  width={"100%"}*/}
                                {/*              >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Bank NOC -Form 35<div*/}
                                {/*                    style={{color: "red"}}>*</div></span>*/}
                                {/*              </FileUpload>*/}
                                {/*          </div>*/}
                                {/*          <div className="col-md-3 col-sm-12">*/}
                                {/*              <FileUpload*/}
                                {/*                  id={"pan_card"}*/}
                                {/*                  accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*                  documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*                  documentUrlData={documentUrlDataPublic}*/}
                                {/*                  onChange={(val) => handleInput(val, 'pan_card')}*/}
                                {/*                  prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Aadhar Card/ Pan Card/ Mobile Number/Original RC Photograph " : ""}*/}
                                {/*                  width={"100%"}*/}
                                {/*              >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Aadhar Card/ Pan Card/ Mobile Number/Original RC Photograph <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*              </FileUpload>*/}
                                {/*          </div>*/}
                                {/*          <div className="col-md-3 col-sm-12">*/}
                                {/*              <FileUpload*/}
                                {/*                  id={"form_34"}*/}
                                {/*                  accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*                  documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*                  documentUrlData={documentUrlDataPublic}*/}
                                {/*                  onChange={(val) => handleInput(val, 'form_34')}*/}
                                {/*                  prefilledFilename={inputList[0]?.form_34 ? "Form 34 with Bank stamp" : ""}*/}
                                {/*                  width={"100%"}*/}
                                {/*              >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 34 with Bank stamp<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*              </FileUpload>*/}
                                {/*          </div>*/}
                                {/*          <div className="col-md-3 col-sm-12">*/}
                                {/*              <FileUpload*/}
                                {/*                  id={"fore_closure"}*/}
                                {/*                  accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*                  documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*                  documentUrlData={documentUrlDataPublic}*/}
                                {/*                  onChange={(val) => handleInput(val, 'fore_closure')}*/}
                                {/*                  prefilledFilename={inputList[0]?.form_34 ? "Fore closure receipt " : ""}*/}
                                {/*                  width={"100%"}*/}
                                {/*              >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Fore closure receipt</span>*/}
                                {/*              </FileUpload>*/}
                                {/*          </div>*/}
                                {/*      </>*/}
                                {/*  }*/}
                                {/*{loanApplicationByIdResponse?.data?.loan_type && loanApplicationByIdResponse?.data?.loan_type === 'Purchase' &&*/}
                                {/*    loanApplicationByIdResponse?.data?.vehicle_details?.current_hypothecation && loanApplicationByIdResponse?.data?.vehicle_details?.current_hypothecation === 'No' &&*/}
                                {/*    <>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"original_rc"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'original_rc')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Original RC" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Original RC<div*/}
                                {/*                    style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_29"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_29')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Form 29 with seller signature" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 29 with seller signature <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_30"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_30')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_30 ? "Form 30 with seller signature " : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 30 with seller signature <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*            <ConstantInput*/}
                                {/*                label={"Mobile number of Seller"}*/}
                                {/*                handleChange={(val) =>*/}
                                {/*                    handleInput(val, 'seller_mobile_no')*/}
                                {/*                }*/}
                                {/*                value={inputList[0]?.seller_mobile_no}*/}
                                {/*                // disabled={isEdit}*/}
                                {/*                type="text"*/}
                                {/*                checkDigits={true}*/}
                                {/*                maxLength={10}*/}
                                {/*                minLength={10}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*            <ConstantInput*/}
                                {/*                label={"Mobile number of Buyer"}*/}
                                {/*                handleChange={(val) =>*/}
                                {/*                    handleInput(val, 'buyer_mobile_no')*/}
                                {/*                }*/}
                                {/*                value={inputList[0]?.buyer_mobile_no}*/}
                                {/*                // disabled={isEdit}*/}
                                {/*                type="text"*/}
                                {/*                checkDigits={true}*/}
                                {/*                maxLength={10}*/}
                                {/*                minLength={10}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"fore_closure"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'fore_closure')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_34 ? "Form 34 with bank stamp" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 34 with bank stamp<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"seller_aadhar_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'seller_aadhar_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.seller_aadhar_card ? "Seller Aadhar Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Seller Aadhar Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"seller_pan_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'seller_pan_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.seller_pan_card ? "Seller Pan Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Seller Pan Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"buyer_aadhar_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'buyer_aadhar_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.buyer_aadhar_card ? "Buyer Aadhar Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Buyer Aadhar Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"buyer_pan_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'buyer_pan_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.buyer_pan_card ? "Buyer Pan Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Buyer Pan Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*    </>*/}
                                {/*}*/}
                                {/*{loanApplicationByIdResponse?.data?.loan_type && loanApplicationByIdResponse?.data?.loan_type === 'Refinance' &&*/}
                                {/*    <>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"original_rc"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'original_rc')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Original RC" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Original RC<div*/}
                                {/*                    style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}

                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_34"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_34')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_34 ? "Form-34 with Bank stamp" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form-34 with Bank stamp<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*    </>*/}
                                {/*}*/}
                                {/*{loanApplicationByIdResponse?.data?.loan_type && loanApplicationByIdResponse?.data?.loan_type === 'Purchase' &&*/}
                                {/*    loanApplicationByIdResponse?.data?.vehicle_details?.current_hypothecation && loanApplicationByIdResponse?.data?.vehicle_details?.current_hypothecation === 'Yes' &&*/}
                                {/*    <>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"bank_noc_form_35"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'bank_noc_form_35')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Bank NOC -Form 35" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Bank NOC -Form 35</span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"original_rc"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'original_rc')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Original RC" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Original RC<div*/}
                                {/*                    style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_29"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_29')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Form 29 with seller signature" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 29 with seller signature <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_30"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_30')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_30 ? "Form 30 with seller signature " : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 30 with seller signature <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*            <ConstantInput*/}
                                {/*                label={"Mobile number of Seller"}*/}
                                {/*                handleChange={(val) =>*/}
                                {/*                    handleInput(val, 'seller_mobile_no')*/}
                                {/*                }*/}
                                {/*                value={inputList[0]?.seller_mobile_no}*/}
                                {/*                // disabled={isEdit}*/}
                                {/*                type="text"*/}
                                {/*                checkDigits={true}*/}
                                {/*                maxLength={10}*/}
                                {/*                minLength={10}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*            <ConstantInput*/}
                                {/*                label={"Mobile number of Buyer"}*/}
                                {/*                handleChange={(val) =>*/}
                                {/*                    handleInput(val, 'buyer_mobile_no')*/}
                                {/*                }*/}
                                {/*                value={inputList[0]?.buyer_mobile_no}*/}
                                {/*                // disabled={isEdit}*/}
                                {/*                type="text"*/}
                                {/*                checkDigits={true}*/}
                                {/*                maxLength={10}*/}
                                {/*                minLength={10}*/}
                                {/*            />*/}
                                {/*        </div>*/}
                                {/*        <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"fore_closure"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'fore_closure')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_34 ? "Form 34 with bank stamp" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form 34 with bank stamp<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"seller_aadhar_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'seller_aadhar_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.seller_aadhar_card ? "Seller Aadhar Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Seller Aadhar Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"seller_pan_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'seller_pan_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.seller_pan_card ? "Seller Pan Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Seller Pan Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"buyer_aadhar_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'buyer_aadhar_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.buyer_aadhar_card ? "Buyer Aadhar Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Buyer Aadhar Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"buyer_pan_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'buyer_pan_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.buyer_pan_card ? "Buyer Pan Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Buyer Pan Card<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*    </>*/}
                                {/*}*/}
                                {/*{loanApplicationByIdResponse?.data?.loan_type && loanApplicationByIdResponse?.data?.loan_type === 'Refinance-HP' &&*/}
                                {/*    <>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"original_rc"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'original_rc')}*/}
                                {/*            prefilledFilename={inputList[0]?.bank_noc_form_35 ? "Original RC" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*                <span className="btn btn-transparent"*/}
                                {/*                      style={{minWidth: '100%'}}>Original RC<div*/}
                                {/*                    style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}

                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"form_34"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'form_34')}*/}
                                {/*            prefilledFilename={inputList[0]?.form_34 ? "Form-34 with Bank stamp" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Form-34 with Bank stamp<div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-sm-4">*/}
                                {/*        <ConstantInput*/}
                                {/*            label={"Customer number of Buyer"}*/}
                                {/*            handleChange={(val) =>*/}
                                {/*                handleInput(val, 'customer_mobile_no')*/}
                                {/*            }*/}
                                {/*            value={inputList[0]?.customer_mobile_no}*/}
                                {/*            // disabled={isEdit}*/}
                                {/*            type="text"*/}
                                {/*            checkDigits={true}*/}
                                {/*            maxLength={10}*/}
                                {/*            minLength={10}*/}
                                {/*            required={true}*/}
                                {/*            isStarRequired={true}*/}
                                {/*        />*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"customer_aadhar_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'customer_aadhar_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.customer_aadhar_card ? "Customer Aadhar Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Customer Aadhar Card*/}
                                {/*              <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*      <div className="col-md-3 col-sm-12">*/}
                                {/*        <FileUpload*/}
                                {/*            id={"customer_pan_card"}*/}
                                {/*            accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                {/*            documentUrlData={documentUrlDataPublic}*/}
                                {/*            onChange={(val) => handleInput(val, 'customer_pan_card')}*/}
                                {/*            prefilledFilename={inputList[0]?.customer_pan_card ? "Customer Pan Card" : ""}*/}
                                {/*            width={"100%"}*/}
                                {/*        >*/}
                                {/*              <span className="btn btn-transparent"*/}
                                {/*                    style={{minWidth: '100%'}}>Customer Pan Card*/}
                                {/*              <div*/}
                                {/*                  style={{color: "red"}}>*</div></span>*/}
                                {/*        </FileUpload>*/}
                                {/*      </div>*/}
                                {/*    </>*/}
                                {/*}*/}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalPop
                    title={"Change Status"}
                    show={changeCarLoanStatusModalOpen}
                    handleModalHide={() => {
                        setChangeCarLoanStatusModalOpen(false);
                    }}
                >
                    <Fragment>
                        <FormSection>
                            <div className={s.root}>
                                <div className={s.root}>
                                    <div>
                                        <div className="col-sm-12 col-ms-12 ">
                                            <DropDownInput
                                                label={"Status"}
                                                data={(rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.available_current_states) ? rcCaseByIdResponse?.data?.available_current_states : []}
                                                value={""}
                                                isStarRequired={true}
                                                getIdValue={(val) => {
                                                    handleRtoInput('document_status', val.id)
                                                }}
                                                required={true}
                                            />
                                        </div>
                                        {rtoInputList[0]['document_status'] === 'ORIGINAL_DOCUMENT_APPROVED' &&
                                            <div className="col-sm-4 d-flex">
                                                <input type="checkbox"
                                                       name="vehicle1"
                                                       onChange={(e) => {
                                                           handleRtoInput('document_confirmation', e.target.checked)
                                                       }}
                                                       style={{
                                                           width: '6%',
                                                           marginTop: '-8px',
                                                           marginRight: '6px'
                                                       }}
                                                />
                                                <label htmlFor="Is All Documents is Collected">Is All
                                                    Documents is
                                                    Collected</label><br/>
                                            </div>
                                        }

                                        {rtoInputList[0]['document_status'] === 'RTO_APPROVED' &&
                                            <div className="col-md-12 col-sm-12">
                                                <FileUpload
                                                    id={'RTO RECEIPT'}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleRtoInput('RTO_RECEIPT', val)}
                                                    prefilledFilename={(rtoInputList[0] && rtoInputList[0]['url'] !== undefined) ? 'RTO RECEIPT' : ""}
                                                    width={"100%"}
                                                >
                                                          <span className="btn btn-transparent"
                                                                style={{minWidth: '100%'}}>RTO RECEIPT
                                                              <div
                                                                  style={{color: "red"}}>*
                                                                      </div>
                                                            </span>
                                                </FileUpload>
                                            </div>
                                        }
                                        {rtoInputList[0]['document_status'] === 'RTO_APPROVED' &&
                                            <div className="col-md-12 col-sm-12">
                                                <FileUpload
                                                    id={'Screenshot of Vahan'}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleRtoInput('RC_TRANSFER_PROOF', val)}
                                                    prefilledFilename={(rtoInputList[0] && rtoInputList[0]['url'] !== undefined) ? 'Screenshot of Vahan' : ""}
                                                    width={"100%"}
                                                >
                                                          <span className="btn btn-transparent"
                                                                style={{minWidth: '100%'}}>Screenshot of Vahan
                                                              <div
                                                                  style={{color: "red"}}>*
                                                                      </div>
                                                            </span>
                                                </FileUpload>
                                            </div>
                                        }
                                        <div className="col-sm-12 col-ms-12 ">
                                            <ConstantInput
                                                label={localization.remark}
                                                type="text"
                                                value={""}
                                                required={true}
                                                className="my-custom-datepicker-component "
                                                handleChange={(val) =>
                                                    handleRtoInput('remark', val)
                                                }
                                            />
                                        </div>

                                        <br/>
                                        <div
                                            className="confirm-button"
                                            style={{marginBottom: "15px"}}
                                        >
                                            <div className="col-md-6 col-sm-6">
                                                <div className={s.button} style={{width: "36%"}}>
                                                    <Button onClick={() => submitStatus()}>
                                                        {"Final Submit"}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </FormSection>
                    </Fragment>
                </ModalPop>
            </Fragment>
    );
};

export default RTODocuments;
